import { ReactNode, Fragment } from 'react'

import {
  StyledTableOfContent,
  StyledSeparator,
  StyledContent,
  StyledRefContent,
} from './index.styled'

export type AnchorRef = {
  label: string
  id: string
}

export type TableOfContentItem = ReactNode | string | AnchorRef

export type Props = {
  size?: 'lg' | 'md' | 'sm'
  className?: string
  contentClassName?: string
  contents: Array<TableOfContentItem>
  separator?: ReactNode | string
}

function instanceOfAnchorRef(object: any): object is AnchorRef {
  if (!object || typeof object !== 'object') return false
  return 'label' in object && 'id' in object
}

const TableOfContent = ({
  className,
  size = 'md',
  contents,
  separator = '|',
  contentClassName,
}: Props) => {
  return (
    <StyledTableOfContent className={className} data-size={size}>
      {contents.map((content, index) => {
        if (!content) return null
        return (
          <Fragment key={index}>
            {instanceOfAnchorRef(content) ? (
              <StyledRefContent
                href={`#${content.id}`}
                className={contentClassName}
              >
                {content.label}
              </StyledRefContent>
            ) : (
              <StyledContent className={contentClassName}>
                {content}
              </StyledContent>
            )}
            {index + 1 < contents.length && (
              <StyledSeparator>{separator}</StyledSeparator>
            )}
          </Fragment>
        )
      })}
    </StyledTableOfContent>
  )
}

export { TableOfContent }
